const TYPE_STYLES = {
  architecture:    "text-emerald-400/90 bg-zinc-800/60 border border-emerald-800/40",
  decision:        "text-amber-300/85 bg-zinc-800/60 border border-amber-900/40",
  bugfix:          "text-red-400/85 bg-zinc-800/60 border border-red-900/40",
  discovery:       "text-violet-400/85 bg-zinc-800/60 border border-violet-900/40",
  pattern:         "text-sky-400/85 bg-zinc-800/60 border border-sky-900/40",
  config:          "text-zinc-400/80 bg-zinc-800/60 border border-zinc-700/50",
  preference:      "text-teal-400/85 bg-zinc-800/60 border border-teal-900/40",
  session_summary: "text-zinc-400/75 bg-zinc-800/60 border border-zinc-700/50",
  reference:       "text-sky-300/85 bg-zinc-800/60 border border-sky-900/40",
  chore:           "text-zinc-500/80 bg-zinc-800/60 border border-zinc-700/40",
  synthesis:       "text-orange-400/85 bg-zinc-800/60 border border-orange-900/40",
  session_context: "text-indigo-300/85 bg-zinc-800/60 border border-indigo-900/40",
  concept:         "text-fuchsia-400/85 bg-zinc-800/60 border border-fuchsia-900/40",
}

export default function TypeBadge({ type }) {
  const styles = TYPE_STYLES[type] ?? "text-zinc-400/80 bg-zinc-800/60 border border-zinc-700/50"
  return (
    <span className={`inline-block px-1.5 py-0.5 rounded-md text-[11px] font-mono ${styles}`}>
      {type}
    </span>
  )
}
